import template from "./dialog-config.html";
import css from "./dialog-config.css";
import Dialog from "dialog";
import sleep from "sleep";


class ConfigEZOECDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-ezoec", ConfigEZOECDialog);
	}
	constructor() {
		super();

		document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	async buttonClearCalibration_click() {
      try {
        this.buttonClearCalibration.style.pointerEvents = "none";
        this.buttonClearCalibration.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoec_clearCalibration");
        this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonClearCalibration.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonClearCalibration.icon.iconname = "dialog-ok";
        this.buttonClearCalibration.style.pointerEvents = "";
      }
	}
	async buttonCalibrateDry_click() {
      try {
        this.buttonCalibrateDry.style.pointerEvents = "none";
        this.buttonCalibrateDry.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoec_calibrateDry");
        this.buttonCalibrateDry.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateDry.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateDry.icon.iconname = "dialog-ok";
        this.buttonCalibrateDry.style.pointerEvents = "";
      }
	}
	async buttonCalibrateSingle_click() {
      try {
        this.buttonCalibrateSingle.style.pointerEvents = "none";
        this.buttonCalibrateSingle.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoec_calibrateSingle", this.spinnerSingle.value);
        this.buttonCalibrateSingle.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateSingle.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateSingle.icon.iconname = "dialog-ok";
        this.buttonCalibrateSingle.style.pointerEvents = "";
      }
	}
	async buttonCalibrateLow_click() {
      try {
        this.buttonCalibrateLow.style.pointerEvents = "none";
        this.buttonCalibrateLow.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoec_calibrateLow", this.spinnerLow.value);
        this.buttonCalibrateLow.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateLow.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateLow.icon.iconname = "dialog-ok";
        this.buttonCalibrateLow.style.pointerEvents = "";
      }
	}
	async buttonCalibrateHigh_click() {
      try {
        this.buttonCalibrateHigh.style.pointerEvents = "none";
        this.buttonCalibrateHigh.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoec_calibrateHigh", this.spinnerHigh.value);
        this.buttonCalibrateHigh.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateHigh.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateHigh.icon.iconname = "dialog-ok";
        this.buttonCalibrateHigh.style.pointerEvents = "";
      }
	}  
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.ezoecSensor.id;
		this.textboxDeviceStatus.value = devices.ezoecSensor.status;
		this.textboxValue.value = devices.ezoecSensor.value;
		this.textboxCalibrationStatus.value = devices.ezoecSensor.calibrationStatus;        
	}
	buttonClose_click() {
		this.close();
	}  
}

ConfigEZOECDialog.constructor();

export default ConfigEZOECDialog;